import AvatarProfileChanger from './AvatarProfileChanger';

export default AvatarProfileChanger;
